import React from 'react';

const RegularButton = ({
  text,
  colorScheme = 'dark',
  selected = false,
  onClick,
  className = '',
}) => {
  const baseButtonClass =
    'flex items-center justify-center text-sm font-medium px-3 py-2 rounded-md transition duration-200 w-full';

  let buttonClass = '';

  if (colorScheme === 'dark') {
    if (selected) {
      buttonClass = 'bg-white/15 text-white border border-white/30';
    } else {
      buttonClass =
        'text-white/70 border border-transparent hover:bg-white/10 hover:text-white';
    }
  } else if (colorScheme === 'light') {
    if (selected) {
      buttonClass = 'bg-dark-blue text-white border border-dark-blue';
    } else {
      buttonClass =
        'bg-white border border-border-light text-primary-text hover:bg-content-bg';
    }
  }

  return (
    <button
      className={`${baseButtonClass} ${buttonClass} ${className}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default RegularButton;
